import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketplaceManagerComponent } from './components/marketplace-manager/marketplace-manager.component';
import { TenantWebchatConfigurationComponent } from './components/tenant-webchat-configuration/tenant-webchat-configuration.component';
import { ManageWebchatComponent } from './components/manage-webchat/manage-webchat.component';
import { ManageCustomerHomepageComponent } from './components/manage-customer-homepage/manage-customer-homepage.component';

const routes: Routes = [
  { path: 'marketplace', component: MarketplaceManagerComponent },
  { path: 'webchat', component: ManageWebchatComponent },
  { path: 'customer-homepage', component: ManageCustomerHomepageComponent },
  { path: 'webchat-config', component: TenantWebchatConfigurationComponent },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SolutionsManagerRoutingModule {}
